import { useEffect, useRef, useState } from "react";

export default function useRevealOnce(options = {}) {
  const elementRef = useRef(null);
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    if (isRevealed) return undefined;

    const element = elementRef.current;
    if (!element) return undefined;

    if (!("IntersectionObserver" in window)) {
      setIsRevealed(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setIsRevealed(true);
        observer.disconnect();
      },
      {
        rootMargin: options.rootMargin || "0px 0px -24% 0px",
        threshold: options.threshold ?? 0.22,
      }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [isRevealed, options.rootMargin, options.threshold]);

  return { elementRef, isRevealed };
}
